module.exports = __webpack_public_path__ + "static/media/106.44e99901.jpg";